import { cloneDeep } from 'lodash-es';
import { FieldValues, UseFormReturn } from 'react-hook-form';

export const customResetForm = <T extends FieldValues>(form: UseFormReturn<T>, data: T) => {
	// for array
	if (data && Array.isArray(data)) {
		for (let i = 0; i < data.length; i++) {
			const value = data[i];
			const cloned = cloneDeep(value);

			form.setValue(i as any, null as any);
			form.setValue(i as any, cloned);
		}

		return;
	}

	// for object
	if (data && typeof data === 'object') {
		for (const key of Object.keys(data)) {
			const value = data[key];
			const cloned = cloneDeep(value);

			form.setValue(key as any, null as any);
			form.setValue(key as any, cloned);
		}

		return;
	}

	// for other types
	form.reset(data);
};
